module.exports = __webpack_public_path__ + "static/mayfair-38c8ca32d308b20c2d7da2ee516e27fb.svg";